import { useQuery, QueryFunction } from "react-query";
import { AxiosError } from "axios";

import { fetchCustomViews } from "modules/core/api/custom_views";

import { CustomView, CustomViewType } from "modules/core/types/entities";

type CustomViewsQueryKey = [string, { view_type: CustomViewType }];

export const CUSTOM_VIEWS_QUERY_KEY = "/custom_views";

export const getCustomViewsQueryKey = (args: {
  view_type: CustomViewType;
}): CustomViewsQueryKey => [CUSTOM_VIEWS_QUERY_KEY, args];

const queryFn: QueryFunction<CustomView[], CustomViewsQueryKey> = ({
  queryKey: [, { view_type }]
}) => fetchCustomViews({ view_type });

export const useCustomViewsQuery = (
  args: { view_type: CustomViewType },
  options: { enabled?: boolean } = {}
) => {
  const query = useQuery<
    CustomView[],
    AxiosError,
    CustomView[],
    CustomViewsQueryKey
  >({
    queryKey: getCustomViewsQueryKey(args),
    queryFn,
    ...options
  });

  return query;
};
